export default "__VITE_ASSET__Ckqioiz4__"